// extracted by mini-css-extract-plugin
export default {"container":"SubscribeNewsletter_container__O-dHN"};